<template>
  <div
    class="conmon-top"
    id="event-identity"
  >
    <el-container>
      <el-main
        style="padding: 0"
        class="table-first-style"
      >
        <el-row style="margin-top: 20px;background-color: #fff;display: flex;justify-content: center">
          <div style="display: flex;padding: 30px 0;width: 500px" v-loading="loadingAttr">
            <el-form
              ref="form"
              :model="form"
              label-width="140px"
              :rules="formRules"
            >
              <el-form-item
                v-for="(item, index) in attrList" :key="index"
                :label="item.name+ ':'"
                :required="item.required === 0? false:true"
              >
                  <el-input :disabled="item.isEdit===0?($route.query.type ==='add'? false : true):false" v-if="item.type=='input' && item.identity!='product_id'" style="width: 300px" v-model="form[item.identity]" :value="item.value" :type="item.type" :placeholder="'请输入'+  item.name"></el-input>
                  <el-input :disabled="item.isEdit==0?true:false" v-if="item.type=='input' && item.identity=='product_id'" style="width: 300px" v-model="form[item.identity]" :value="item.value" :type="item.type" placeholder="由系统生成"></el-input>
                  <el-select :disabled="item.isEdit===0?($route.query.type ==='add'? false : true):false" style="width: 300px" v-if="item.type=='select'" v-model="form[item.identity]" @change="update">
                      <el-option v-for="(item,index) in JSON.parse(item.options)" :key="index" :label="item" :value="item"></el-option>
                  </el-select>
                  <el-radio-group :disabled="item.isEdit===0?($route.query.type ==='add'? false : true):false" v-if="item.type === 'radio'" v-model="form[item.identity]" @change="update">
                      <el-radio v-for="(item,index) in JSON.parse(item.options)" :key="index" :label="item">
                          {{item}}
                      </el-radio>
                  </el-radio-group>
                  <el-select :disabled="item.isEdit===0?($route.query.type ==='add'? false : true):false" style="width: 300px" filterable v-if="item.type === 'multipleSelect'" @change="update"
                             v-model="form[item.identity]" multiple placeholder="请选择">
                      <el-option
                              v-for="item in JSON.parse(item.options)"
                              :key="item"
                              :label="item"
                              :value="item">
                      </el-option>
                  </el-select>
                  <el-input
                          :disabled="item.isEdit===0?($route.query.type ==='add'? false : true):false"
                          v-if="item.type === 'number'"
                          class="diy-input-number"
                          @blur="update"
                          type="number"
                          v-model="form[item.identity]"
                          placeholder="请输入数字" style="width: 300px">
                  </el-input>
                  <el-select
                          :disabled="item.isEdit===0?($route.query.type ==='add'? false : true):false"
                          style="width: 300px"
                          filterable
                          remote
                          @focus="getMyOptions(attr)"
                          v-if="item.type === 'model'"
                          :multiple-limit="10"
                          @change="update"
                          v-model="form[item.identity]"
                          multiple
                          :remote-method="remoteMethod"
                          :loading="loading">
                      <el-option
                              v-for="item in item.options === undefined ? [] : JSON.parse(item.options)"
                              :key="'model' + item.id"
                              :label="item.value"
                              :value="item.id">
                      </el-option>
                  </el-select>
                  <el-checkbox-group :disabled="item.isEdit===0?($route.query.type ==='add'? false : true):false" style="width: 300px" v-if="item.type=='checkBox'" v-model="form[item.identity]" @change="update">
                      <el-checkbox v-for="(item,index) in JSON.parse(item.options)" :key="index" :label="item">{{ item }}</el-checkbox>
                  </el-checkbox-group>
                  <el-date-picker
                          :disabled="item.isEdit===0?true:false"
                          style="width: 300px"
                          @change="update"
                          v-if="item.type === 'datePicker'"
                          v-model="form[item.identity]"
                          type="date"
                          value-format="yyyy-MM-dd"
                          placeholder="选择日期">
                  </el-date-picker>
                  <el-date-picker
                          :disabled="item.isEdit===0?($route.query.type ==='add'? false : true):false"
                          style="width: 300px"
                          @change="update"
                          v-if="item.type=='dateTimePicker'"
                          v-model="form[item.identity]"
                          type="datetime"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          placeholder="选择日期">
                  </el-date-picker>
                  <el-cascader
                          ref="cascaderAddr"
                          filterable
                          @change="handleChange(item.identity)"
                          :disabled="item.isEdit===0?($route.query.type ==='add'? false : true):false"
                          style="width: 300px"
                          v-if="item.type=='addressPicker'"
                          :options="regionData"
                          v-model="form[item.identity].code">
                  </el-cascader>

              </el-form-item>

<!--              <el-form-item-->
<!--                label="图文详情:"-->
<!--                label-width="140px"-->
<!--              >-->
<!--                <el-upload-->
<!--                  class="pic-uploader"-->
<!--                  action=""-->
<!--                  :show-file-list="false"-->
<!--                  style="display: none;"-->
<!--                ></el-upload>-->
<!--                &lt;!&ndash;上面这个el-upload没有作用只是为了撑起form&ndash;&gt;-->
<!--                <editor-->
<!--                  v-model="form.content"-->
<!--                  class="picture-text-details"-->
<!--                  :action="uploadURL"-->
<!--                >-->
<!--                </editor>-->
<!--              </el-form-item>-->
              <div style="margin-top: 100px">
                <el-button
                  type="primary"
                  @click="submitAddProduct"
                >保存</el-button>
              </div>
            </el-form>

          </div>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import { regionDataPlus, CodeToText, TextToCode } from 'element-china-area-data'
import { getSaveDataShow, addResourceProduct, updateResourceProduct } from '@/api/set.js'
import { API_HOST } from '@/api/local'
import editor from '@/components/common/editor'
export default {
  name: 'product-add',
  components: {
    // editor
  },
  computed: {
    uploadURL () {
      return API_HOST + 'admin/Upload/upload'
    }
  },
  data () {
    return {
      loadingAttr: false,
      regionData: regionDataPlus,
      loading: false,
      addLabelWidth: '150px',
      attrList: [],
      visible: false,
      previewAddrs: [{ url: '' }],
      publicSentimentImgs: [],
      form: {},
      formRules: {
        manuscriptTitle: [{
          required: true,
          message: '请输入作品名称',
          trigger: 'blur'
        }],
        editorIds: [{
          required: true,
          message: '请选择编辑',
          trigger: 'blur'
        }],
        // reporterIds: [{
        //   required: true,
        //   message: '请选择记者',
        //   trigger: 'blur'
        // }],
        guidanceOfficerIds: [{
          required: true,
          message: '请选择指导主任',
          trigger: 'blur'
        }],
        publishPlatform: [{
          required: true,
          message: '请选择稿件来源',
          trigger: 'blur'
        }],
        publishTime: [{
          required: true,
          message: '请选择发表时间',
          trigger: 'blur'
        }]
      },
      addressObj:{},
      bj: [],
      jz: [],
      bdzr: [],
      kfpt: [
        {
          value: '1',
          label: 'APP'
        }, {
          value: '2',
          label: '报纸'
        }, {
          value: '3',
          label: '舆情'
        }, {
          value: '4',
          label: '其他'
        }
      ],
      fileList: [],
      fileResult: '',
      fileName: '',
      urlkey: '',
      urlParams: {
        name: '',
        key: '',
        policy: '',
        signature: '',
        OSSAccessKeyId: '',
        success_action_status: 200
      },
      ImgUrl: [],
      uploadurl: '',
      fileListLength: ''
    }
  },
  methods: {
    update () {},
    handleChange(id) {
      let lablearr = this.$refs['cascaderAddr'][0].currentLabels
      let value = ''
      let e = this.$refs['cascaderAddr'][0].currentValue
      lablearr.map(function(item,index){
        value = value + item
      })
      this.form[id] = {
        city_text: lablearr[1],
        district_text: lablearr[2],
        code: e,
        province_text: lablearr[0],
        district_code: e[2],
        city_code: e[1],
        text: lablearr,
        province_code: e[0],
        value: value
      }
    },
    conversiontime (timestamp,type) {
      var date = new Date(timestamp)
      var Y = date.getFullYear() + '-'
      var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-'
      var D = (date.getDate()<10?'0'+(date.getDate()):date.getDate()) + ' '
      if(type !== 'datePicker') {
        var h = (date.getHours()<10?'0'+(date.getHours()):date.getHours()) + ':'
        var m = (date.getMinutes()<10?'0'+(date.getMinutes()):date.getMinutes())+':'
        var s = (date.getSeconds()<10?'0'+(date.getSeconds()):date.getSeconds())
        return Y+M+D+h+m+s
      } else {
        return Y+M+D
      }

},
    // 回显
    getSaveDataShow (modelId, code) {
      let that = this
      that.loadingAttr = true
      getSaveDataShow(modelId, code).then(res => {
        if(res.data.code == '200') {
          that.loadingAttr = false
          let newForm = {}
          res.data.result.map(function(item, index){
            if(item.type == 'datePicker') {
              item.type = 'dateTimePicker'
            }
            if(item.value == null) {
              item.value = ''
            }
            if(item.options == null || item.options == '') {
              item.options = '[]'
            }
            if(item.identity == 'product_id') {
              item.isEdit = 0
              item.required = 0
            }
            newForm[item.identity] = item.value
            if((item.type == 'dateTimePicker' || item.type == 'datePicker') && that.$route.query.type === 'edit') {
              let t = 0
              if(item.value == null || item.value == 'null' || item.value == '') {
                item.value = {}
                newForm[item.identity] = ''
              } else {
                t = item.value.timestamp*1000
                newForm[item.identity] = that.conversiontime(t, item.type)
              }
            }
          })
          // if(code.length ==0) {
          let attrList1 = []
          res.data.result.map(function(item1,index) {
            if(item1.identity== 'product_create_time' || item1.identity=='product_last_update_time') {
            } else {
              attrList1.push(item1)
            }
          })
          // }
          this.attrList = attrList1
          this.form = newForm
          console.log(this.attrList, 'this.attrList', newForm)
        }
      })
    },
    submitAddProduct () {
      let that = this
      let attrList = this.attrList
      let isTrue = true
      for(var i=0;i< attrList.length;i++) {
        let item = attrList[i]
        if(item.required == 1) {
          if(that.form[item.identity] == '' || that.form[item.identity] == null) {
            _g.toastMsg('error', '请输入'+ item.name)
            isTrue = false
            return
          }
        }
      }
      if(isTrue) {
        // 保存
        if(this.$route.query.type === 'add') {
          this.addResourceProduct()
        } else {
          this.updateResourceProduct()
        }

      }
    },
    // 保存
    addResourceProduct () {
      let that = this
      this.attrList.map(function(item, index) {
        item.value = that.form[item.identity]
        if(item.type == 'addressPicker') {
          if(item.value!=null) {
            if(item.value.code.length ===0) {
              item.value = null
            }
          }
        }
      })
      addResourceProduct({modelId: this.$route.query.modelId, dataList: this.attrList}).then(res => {
        if(res.data.code == '200') {
          _g.toastMsg('success', '保存成功')
          this.$router.go(-1)
        } else {
          _g.toastMsg('error', res.data.message)
        }
      })
    },
    // 编辑
    updateResourceProduct () {
      let that = this
      this.attrList.map(function(item, index) {
        item.value = that.form[item.identity]
        if(item.type == 'addressPicker') {
          if(item.value!=null) {
            if(item.value.code.length ===0) {
              item.value = null
            }
          }
        }
      })
      updateResourceProduct({modelId: this.$route.query.modelId, dataList: this.attrList, id: this.$route.query.code}).then(res => {
        if(res.data.code == '200') {
          _g.toastMsg('success', '编辑成功')
          this.$router.go(-1)
        } else {
          _g.toastMsg('error', res.data.message)
        }
      })
    },
  },
  created () {
    // if(this.$route.query.type === 'edit') {
    //   console.log(this.$route.query.row, 'ttttt')
    //   this.form = this.$route.query.row
    // }
    this.getSaveDataShow(this.$route.query.modelId, this.$route.query.code)
  }
}
</script>

<style scoped>
</style>
